// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multiselect-dropdown {
  border-radius: 4px;
  font-size: 14px;
  font-family: sans-serif;
}

/* Prevent placeholder/value text from wrapping (fixes "Search Sub Head" breaking in narrow cells) */
.multiselect-dropdown [class*="placeholder"],
.multiselect-dropdown [class*="singleValue"] {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 100% !important;
}

.css-1jqq78o-placeholder {
  color: rgba(150, 136, 136, 0.1);
  font-size: 14px;
  font-family: "Poppins", sans-serif;
}

.css-1u9des2-indicatorSeparator {
  display: none;
}

.invalid-dropdown .css-1p3m7a8-multiValue,
.multiselect-dropdown .css-1p3m7a8-multiValue {
  background-color: transparent;
}

.css-tr4s17-option {
  background-color: transparent !important;
  color: inherit !important;
}

.css-1u9des2-indicatorSeparator {
  display: none;
}

.multi-select-dropdown {
  width: 200px;
}

.multiselect-dropdown .react-select__menu {
  background-color: #f5f5f5;
}

.multiselect-dropdown .react-select__menu-list {
  padding: 4px 0;
}

.multiselect-dropdown .react-select__option {
  cursor: pointer;
}

.multiselect-dropdown .css-t3ipsp-control,
.multiselect-dropdown .css-t3ipsp-control:hover {
  border: 2px solid rgb(8, 145, 178) !important;
  background-color: rgb(8, 145, 178, 0.1);
  box-shadow: none;
}

.css-1nmdiq5-menu {
  position: initial !important;
}

.multiselect-dropdown .css-13cymwt-control:hover {
  border-color: rgb(8, 145, 178) !important;
}

.multiselect-dropdown .css-1fdsijx-ValueContainer,
.invalid-dropdown .css-1fdsijx-ValueContainer {
  padding: 2px 12px;
  font-weight: 400;
}

.multiselect-dropdown .css-wsp0cs-MultiValueGeneric,
.invalid-dropdown .css-wsp0cs-MultiValueGeneric {
  color: rgb(23, 23, 23) !important;
  font-size: 14px !important;
  font-weight: 400 !important;
}

.invalid-dropdown .css-13cymwt-control,
.invalid-dropdown .css-13cymwt-control:hover,
.invalid-dropdown .css-t3ipsp-control,
.invalid-dropdown .css-t3ipsp-control:hover {
  box-shadow: 0 0 0 1px rgb(220, 38, 38);
  border-color: rgb(220, 38, 38);
}

.custom-option {
  display: flex;
  align-items: center;
}

.checkmark {
  height: 20px;
  width: 20px;
  min-width: 20px;
  margin-right: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
}

.checkmark.selected {
  background-color: #ff5d02;
}

.checkmark.selected::before {
  content: "✔";
  color: #ffffff;
  font-size: 14px;
}

/* Thin scrollbar styling - Very light/transparent */
/* Using attribute selectors for better compatibility with react-select's dynamic class names */
.multiselect-dropdown [class*="menu-list"]::-webkit-scrollbar {
  width: 2px;
}

.multiselect-dropdown [class*="menu-list"]::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 3px;
}

.multiselect-dropdown [class*="menu-list"]::-webkit-scrollbar-thumb {
  background: rgba(200, 200, 200, 0.3);
  border-radius: 3px;
}

.multiselect-dropdown [class*="menu-list"]::-webkit-scrollbar-thumb:hover {
  background: rgba(180, 180, 180, 0.5);
}

/* For Firefox - very light scrollbar */
.multiselect-dropdown [class*="menu-list"] {
  scrollbar-width: thin;
  scrollbar-color: rgba(200, 200, 200, 0.3) transparent;
}

/* Ensure menu has light gray background */
.multiselect-dropdown [class*="menu"] {
  background-color: #f5f5f5 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/searchableDropDown/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA,oGAAoG;AACpG;;EAEE,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,6CAA6C;EAC7C,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,iCAAiC;EACjC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;;;EAIE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA,oDAAoD;AACpD,+FAA+F;AAC/F;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,uCAAuC;AACvC;EACE,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA,0CAA0C;AAC1C;EACE,oCAAoC;AACtC","sourcesContent":[".multiselect-dropdown {\n  border-radius: 4px;\n  font-size: 14px;\n  font-family: sans-serif;\n}\n\n/* Prevent placeholder/value text from wrapping (fixes \"Search Sub Head\" breaking in narrow cells) */\n.multiselect-dropdown [class*=\"placeholder\"],\n.multiselect-dropdown [class*=\"singleValue\"] {\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  max-width: 100% !important;\n}\n\n.css-1jqq78o-placeholder {\n  color: rgba(150, 136, 136, 0.1);\n  font-size: 14px;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.css-1u9des2-indicatorSeparator {\n  display: none;\n}\n\n.invalid-dropdown .css-1p3m7a8-multiValue,\n.multiselect-dropdown .css-1p3m7a8-multiValue {\n  background-color: transparent;\n}\n\n.css-tr4s17-option {\n  background-color: transparent !important;\n  color: inherit !important;\n}\n\n.css-1u9des2-indicatorSeparator {\n  display: none;\n}\n\n.multi-select-dropdown {\n  width: 200px;\n}\n\n.multiselect-dropdown .react-select__menu {\n  background-color: #f5f5f5;\n}\n\n.multiselect-dropdown .react-select__menu-list {\n  padding: 4px 0;\n}\n\n.multiselect-dropdown .react-select__option {\n  cursor: pointer;\n}\n\n.multiselect-dropdown .css-t3ipsp-control,\n.multiselect-dropdown .css-t3ipsp-control:hover {\n  border: 2px solid rgb(8, 145, 178) !important;\n  background-color: rgb(8, 145, 178, 0.1);\n  box-shadow: none;\n}\n\n.css-1nmdiq5-menu {\n  position: initial !important;\n}\n\n.multiselect-dropdown .css-13cymwt-control:hover {\n  border-color: rgb(8, 145, 178) !important;\n}\n\n.multiselect-dropdown .css-1fdsijx-ValueContainer,\n.invalid-dropdown .css-1fdsijx-ValueContainer {\n  padding: 2px 12px;\n  font-weight: 400;\n}\n\n.multiselect-dropdown .css-wsp0cs-MultiValueGeneric,\n.invalid-dropdown .css-wsp0cs-MultiValueGeneric {\n  color: rgb(23, 23, 23) !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n}\n\n.invalid-dropdown .css-13cymwt-control,\n.invalid-dropdown .css-13cymwt-control:hover,\n.invalid-dropdown .css-t3ipsp-control,\n.invalid-dropdown .css-t3ipsp-control:hover {\n  box-shadow: 0 0 0 1px rgb(220, 38, 38);\n  border-color: rgb(220, 38, 38);\n}\n\n.custom-option {\n  display: flex;\n  align-items: center;\n}\n\n.checkmark {\n  height: 20px;\n  width: 20px;\n  min-width: 20px;\n  margin-right: 8px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.checkmark.selected {\n  background-color: #ff5d02;\n}\n\n.checkmark.selected::before {\n  content: \"✔\";\n  color: #ffffff;\n  font-size: 14px;\n}\n\n/* Thin scrollbar styling - Very light/transparent */\n/* Using attribute selectors for better compatibility with react-select's dynamic class names */\n.multiselect-dropdown [class*=\"menu-list\"]::-webkit-scrollbar {\n  width: 2px;\n}\n\n.multiselect-dropdown [class*=\"menu-list\"]::-webkit-scrollbar-track {\n  background: transparent;\n  border-radius: 3px;\n}\n\n.multiselect-dropdown [class*=\"menu-list\"]::-webkit-scrollbar-thumb {\n  background: rgba(200, 200, 200, 0.3);\n  border-radius: 3px;\n}\n\n.multiselect-dropdown [class*=\"menu-list\"]::-webkit-scrollbar-thumb:hover {\n  background: rgba(180, 180, 180, 0.5);\n}\n\n/* For Firefox - very light scrollbar */\n.multiselect-dropdown [class*=\"menu-list\"] {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(200, 200, 200, 0.3) transparent;\n}\n\n/* Ensure menu has light gray background */\n.multiselect-dropdown [class*=\"menu\"] {\n  background-color: #f5f5f5 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
